import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* getAward({params}) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_CURRENT_AWARD, {params})
    );
    yield put(actionCreators.getAwardSuccess(response.data.data));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    
  }
}

function* getMyAwardEntry({ params }) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_CURRENT_AWARD_ENTRY, {params})
    );
    yield put(actionCreators.getMyAwardEntrySuccess(response.data.data || {}));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    
  }
}

function* getAwardEntries(params) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_AWARD_ENTRY, params)
    );
    yield put(actionCreators.getAwardEntriesSuccess(response.data.data));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    
  }
}

function* voteAwardEntry({params}) {
  try {
    const response = yield call(() =>
      API.post(ROUTES.API_AWARD_VOTE, params)
    );
    yield put(actionCreators.votingAwardEntrySuccess(response.data.data));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    console.log(error)
  }
}

function* checkVotedAwardEntry() {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_AWARD_CHECK_VOTED)
    );
    yield put(actionCreators.checkVotedAwardEntrySuccess(response.data.data));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    console.log(error)
  }
}

function* deleteAwardEntry() {
  try {
    const response = yield call(() =>
      API.post(ROUTES.DELETE_AWARD_ENTRY)
    );
    yield put(actionCreators.deleteAwardEntrySuccess(response.data.data));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    console.log(error)
  }
}

function* award() {
  yield takeLatest(actionTypes.GET_AWARD, getAward);
  yield takeLatest(actionTypes.GET_MY_AWARD_ENTRY, getMyAwardEntry);
  yield takeLatest(actionTypes.GET_AWARD_ENTRY, getAwardEntries);
  yield takeLatest(actionTypes.VOTING_AWARD, voteAwardEntry);
  yield takeLatest(actionTypes.CHECK_VOTED, checkVotedAwardEntry);
  yield takeLatest(actionTypes.DELETE_AWARD_ENTRY, deleteAwardEntry);
}

export default award;
